<template>
  <picture v-lazyload="lazyLoad" v-if="src" class="responsive-image-wrapper concrete-image" :style="pictureStyle">
    <source v-if="thumb.base" v-for="thumb in matchedThumbnails"
            :media="constructMediaQuery( thumb.viewport )"
            :data-srcset="constructSrcSet( thumb )"/>
    <img class="img-responsive" :data-src="src" :class="imgClass" :title="title" :alt="alt" :style="imgStyle" :data-thumbnail-type="bestFit.type"/>
  </picture>
  <p v-else class="alert alert-danger small">Img not found</p>
</template>
<style></style>
<script>
export default {
  name: "responsive-concrete-image",
  props: {
    availableThumbnails: {
      type: Object,
      default: false
    },
    src: String,
    aspectRatio: String,
    lazyLoad: {type: Boolean, default: true},
    alt: String,
    imgClass: String,
    title: String,
    debug: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      currentViewport: null,
      height: null,
      width: null,
      breakpoints: {
        xl: 1900,
        lg: 1200,
        md: 992,
        sm: 768,
        xs: 0
      },
      bestFit: false,
      matchedThumbnails: {}
    }
  },
  methods: {
    determineViewport: function() {
      var w = window.innerWidth;
      for (const [key, value] of Object.entries(this.breakpoints)) {
        if(w >= value){
          this.currentViewport = key;
          return key
        }
      }
    },
    determineSize: function() {
      this.width = this.$el.clientWidth;
      var ratio = eval(this.aspectRatio);
      this.height = Math.round(this.width / ratio);
      if(this.debug)console.log({msg:'Determined size:', width: this.width, height:this.height})
    },
    findBestFitting: function( ) {
      let match = false;
      let dbl = false;
      let availableThumbnailsArr = Object.values(this.availableThumbnailObjects);
      for (let i = 0; i < availableThumbnailsArr.length; i++){
        let thumb = availableThumbnailsArr[i];
        if(thumb['type'].includes('_2x'))continue;
        if(this.debug)console.log({msg:'evaluating thumb with ratio:', targetWidth: this.width, width: thumb.width, type:thumb.type, ratio1:eval(this.aspectRatio).toFixed(2), ratio2: eval(thumb.aspect).toFixed(2)})
        if( (thumb.height == this.height && thumb.width == this.width) ||
            (thumb.width >= this.width && this.aspectRatio && eval(this.aspectRatio).toFixed(2) == eval(thumb.aspect).toFixed(2))){
          match = thumb;
          break;
        }
      };
      if(!match){
        for (let i = 0; i < availableThumbnailsArr.length; i++){
          let thumb = availableThumbnailsArr[i];
          if(thumb.type.includes('_2x'))continue;
          if(this.debug)console.log({msg:'evaluating thumb:', targetWidth: this.width, width: thumb.width, type:thumb.type, ratio2: eval(thumb.aspect).toFixed(2)})
          if(thumb.width >= this.width){
            match = thumb;
            break;
          }
        };
      }

      if(match){
        this.bestFit = match;
        if(this.debug)console.log({msg:'best Image detected:', targetWidth: this.width, typeWidth:match.width, type:match.type});
        dbl = availableThumbnailsArr.find(function(e){
          return e.type == match.type+'_2x'
        });
        if(dbl){
          if(this.debug)console.log({msg:'highRes Image for current detected:', targetWidth: this.width, typeWidth:dbl.width, type:dbl.type});
        }
        let newEntry = {
          viewport: this.currentViewport,
          type: match.type,
          base: match.path,
          double: (dbl)?dbl.path:false
        }
        if(!this.matchedThumbnails[this.currentViewport]){
          this.matchedThumbnails[this.currentViewport] = newEntry;
        }
      }
      return;
    },
    constructMediaQuery: function ( viewport ) {
      let width = this.breakpoints[viewport];
      if(width === 0) return null;
      return '(min-width: '+ width +'px)'
    },
    constructSrcSet: function( thumb ){
      if(thumb.double){
        return thumb.double+' 2x,'+thumb.base+' 1x';
      }
      return thumb.base+' 1x';
    },
    updateLoaded: function() {
      if(this.$el.classList.contains('loaded')){
        const imageElements = Array.from(this.$el.children).filter(
            el => el.nodeName === "IMG" || el.nodeName === "SOURCE"
        );
        if (imageElements.length > 0)imageElements.forEach(function(imageElement) {
          if(imageElement.dataset.src)imageElement.src = imageElement.dataset.src;
          if(imageElement.dataset.srcset)imageElement.srcset = imageElement.dataset.srcset;
        });
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.determineViewport();
    })
  },
  watch: {
    currentViewport: function(newVal, oldVal) {
      if(newVal != oldVal){
        this.determineSize();
        this.findBestFitting();
        this.$nextTick(() => {
          this.updateLoaded();
        })
      }
    }
  },
  created() {
    window.addEventListener("resize", this.determineViewport);
  },
  destroyed() {
    window.removeEventListener("resize", this.determineViewport);
  },
  computed: {
    pictureStyle:function(){
      return 'aspect-ratio:'+this.aspectRatio;
    },
    imgStyle: function(){
      return '';
    },
    availableThumbnailObjects: function(){
      if(typeof this.availableThumbnails === 'string'){
        return JSON.parse(this.availableThumbnails);
      }
      return this.availableThumbnails;
    }
  }
}
</script>
